<div class="p-3">
    <div class="row">
        <div class="col-12 col-md-4">
            <div class="card">
                <div class="card-header">
                    <h2 class="card-title mb-0">Data Export</h2>
                </div>
                <div class="card-body">
                    <form (submit)="export()">
                        <div class="mb-3">
                            <label for="type" class="form-label">Type</label>
                            <select class="form-select" [(ngModel)]="type" name="type">
                                <option value="player">Player</option>
                                <option value="new-register">New Register Player</option>
                                <option value="agent">Agent</option>
                            </select>
                        </div>
                        <div class="mb-3" *ngIf="type == 'new-register'">
                            <label for="date_from" class="form-label">Date From</label>
                            <input type="date" class="form-control" [(ngModel)]="date_from" name="date_from">
                        </div>
                        <div class="mb-3" *ngIf="type == 'new-register'">
                            <label for="date_to" class="form-label">Date To</label>
                            <input type="date" class="form-control" [(ngModel)]="date_to" name="date_to">
                        </div>
                        <button class="btn btn-primary w-100" type="submit">Export</button>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>